import { graphql, useFragment } from 'react-relay';

import { useShowVimeoVideo_viewer$key } from './__generated__/useShowVimeoVideo_viewer.graphql';
import { useShowVimeoVideo_item$key } from './__generated__/useShowVimeoVideo_item.graphql';

const viewerFragment = graphql`
    fragment useShowVimeoVideo_viewer on Viewer {
        videoUploadToolsFeatureFlag: featureFlag(feature: "videoUploadTools")
    }
`;

const itemFragment = graphql`
    fragment useShowVimeoVideo_item on Item {
        videoVimeo {
            status
            vimeoId
        }
        reviews {
            videoReview {
                status
            }
        }
    }
`;

export const useShowVimeoVideo = ({
    viewer: viewerRef,
    item: itemRef,
}: {
    viewer?: useShowVimeoVideo_viewer$key | null;
    item?: useShowVimeoVideo_item$key | null;
}): boolean => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const item = useFragment(itemFragment, itemRef);

    const videoUploadToolsFeatureFlag = viewer?.videoUploadToolsFeatureFlag;
    const videoVimeo = item?.videoVimeo;
    const videoReviewStatus = item?.reviews?.videoReview?.status;

    return !!(
        videoVimeo?.vimeoId &&
        videoVimeo?.status === 'available' &&
        ((videoUploadToolsFeatureFlag && videoReviewStatus === 'APPROVED') ||
            !videoUploadToolsFeatureFlag)
    );
};
